<template >
  <!-- EVENT ORGANIZER -->
  <router-link
    :to="{name: 'venue-view', params: { venueID: eventVenueId }}"
    itemprop="location"
    itemscope
    itemtype="http://schema.org/Place"
    @click.native="$analytics.logEvent('view_item', { page_name: $route.name, item_name: eventVenueName, item_id: eventVenueId, button_name: 'venue_name_on_category_card' })"
    style="line-height: 1.4"
    class="card-row cursor-link has-text-grey-dark is-inline-block"
    v-if="showVenue"
  >
  <meta itemprop="name" :content="eventVenueName">
    <!-- HIDDENLOCALIZATION -->
    <div
      v-if="eventVenueRichAddress"
      style="height:0;width:0;overflow:hidden"
      itemprop="address"
      itemscope
      itemtype="http://schema.org/PostalAddress"
    >
      <span itemprop="streetAddress">{{ eventVenueRichAddress.streetAddress }}</span>
      <br />
      <span itemprop="addressLocality">{{ eventVenueRichAddress.addressLocality }}</span>,
      <span itemprop="addressRegion">{{ eventVenueRichAddress.addressRegion }}</span>
      <span itemprop="postalCode">{{ eventVenueRichAddress.postalCode }}</span>
    </div>
    <!-- END: HIDDENLOCALIZATION -->
    <link itemprop="url" :href="`https://hafta8.com/venue/${eventVenueId}`" />
    <div >
      <figure
        v-if="showVenueLogo"
        class="image is-16x16 is-rounded has-escape"
        style="margin-right: 6px;"
      >
        <img
          v-if="eventVenueAvatarUrl"
          class="is-rounded"
          :src="eventVenueAvatarUrl"
          :alt="eventVenueName"
        />
      </figure>
      <div
      
       class="has-text-weight-normal cursor-link ">
        <span>{{ eventVenueName }}</span>
        <span v-if="eventVenueRichAddress" class="has-text-grey">, {{ eventVenueRichAddress.addressLocality }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    eventVenueId: {
      type: String,
      required: true
    },
    eventVenueName: {
      type: String,
      required: true
    },
    eventVenueRichAddress: {
      type: Object,
      // required: true
    },
    eventVenueAvatarUrl: {
      type: String,
      required: true
    },
    showVenue: {
      type: Boolean,
      default: true
    },
    showVenueLogo: {
      type: Boolean,
      default: false
    }
  }
};
</script>
